/**
 * The type of (redux) action which signals that sip GW service change its
 * availability status.
 *
 * {
 *     type: SIP_GW_AVAILABILITY_CHANGED,
 *     status: string
 * }
 */
export const SIP_GW_AVAILABILITY_CHANGED = 'SIP_GW_AVAILABILITY_CHANGED';
/**
 * The type of the action which signals to invite room participants to the
 * conference through the SIP Jibri service.
 *
 * {
 *     type: SIP_GW_INVITE_ROOMS,
 *     conference: JitsiConference,
 *     rooms: {Immutable.List}
 * }
 */
export const SIP_GW_INVITE_ROOMS = 'SIP_GW_INVITE_ROOMS';
export const SIP_GW_LISTEN = 'SIP_GW_LISTEN';
export const AUTO_CALL = 'AUTO_CALL';
export const SAVE_DATA = 'SAVE_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';
export const SIP_PARTICIPANT_JOINED = 'SIP_PARTICIPANT_JOINED';
export const SIP_PARTICIPANT_LEFT = 'SIP_PARTICIPANT_LEFT';
export const ENABLE_SIP_CALL_IN = 'ENABLE_SIP_CALL_IN';
export const ADD_TMP_SESSION = 'ADD_TMP_SESSION';
export const ADD_SESSION_IN_MAP = 'ADD_SESSION_IN_MAP';
export const REMOVE_SESSION_IN_MAP = 'REMOVE_SESSION_IN_MAP';
export const IS_INVITED = 'IS_INVITED';
export const TOTAL_IN = 'TOTAL_IN';
export const SUCCESS_IN = 'SUCCESS_IN';
export const FAILED_IN = 'FAILED_IN';
export const RESET_IN = 'RESET_IN';
export const ADD_NAME_LIST = 'ADD_NAME_LIST';
export const RESET_NAME_LIST = 'RESET_NAME_LIST';
export const CLEAR_ERROR_MSG_LOGIN = 'CLEAR_ERROR_MSG_LOGIN';
export const SAVE_OLD_NUMBER_CTH = 'SAVE_OLD_NUMBER_CTH';
export const SET_ACTIVE_KICK = 'SET_ACTIVE_KICK';
export const COUNT_CONFIG_SIP = 'COUNT_CONFIG_SIP';
export const MAP_NEW_TO_OLD = 'MAP_NEW_TO_OLD';
export const CHANGE_TOTAL_SIP_INSTANCE = 'CHANGE_TOTAL_SIP_INSTANCE';
export const INCREASE_TOTAL_SIP_INSTANCE = 'INCREASE_TOTAL_SIP_INSTANCE';
export const DECREASE_TOTAL_SIP_INSTANCE = 'DECREASE_TOTAL_SIP_INSTANCE';
